import React from 'react'
import BaseButton from '../atoms/BaseButton'
import RevealOnScroll from '../atoms/RevealOnScroll'
import styles from './CtaBanner.module.css'

export const CtaBanner = () => {
    return (
        <section className={styles.ctaBanner}>
            <RevealOnScroll className={styles.contentWrapper} animation="reveal-up" threshold={0.1}>
                <h2 className={styles.ctaHeading}>Need money now?<br />Our Lenders are Ready to Connect!</h2>
                <p className={styles.ctaSubtext}>With our simple online form, you get matched to trusted lenders in minutes with no long waits, no hidden fees.</p>

                <ul className={styles.ctaChecklist}>
                    <li className={styles.checkItem}><span className={styles.checkIcon}>✓</span> Quick approvals</li>
                    <li className={styles.checkItem}><span className={styles.checkIcon}>✓</span> No hidden costs</li>
                    <li className={styles.checkItem}><span className={styles.checkIcon}>✓</span> Available in most states</li>
                </ul>

                <BaseButton className={styles.ctaButton}>
                    GET YOUR LOANS
                </BaseButton>
            </RevealOnScroll>
        </section>
    )
}

export default CtaBanner
